import { render } from "./Curators.vue?vue&type=template&id=55d292ba&scoped=true"
import script from "./Curators.vue?vue&type=script&lang=js"
export * from "./Curators.vue?vue&type=script&lang=js"

import "./Curators.vue?vue&type=style&index=0&id=55d292ba&scoped=true&lang=css"

import exportComponent from "/builds/playmob1/songreach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d292ba"]])

export default __exports__